import React from 'react';
import PropsExtractor from '../PropsExtractor';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { chronusStore } from '../../chronusStore';

import App, { LeftNavPropsList } from '../../components/specific/LeftNavigation/custom/App';



export default class LeftNavRender {
    static renderLeftNav = () => {
      const node = document.getElementById("left-nav-react");
      createRoot(node).render(
        <Provider store={ chronusStore }>
          <App {...PropsExtractor.modifyBooleans(PropsExtractor.getForList(node, LeftNavPropsList), LeftNavPropsList)}/>
        </Provider>
      );
    };
  }
